/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { useContext } from 'react';
import { fetch } from '@pandora/fetch';
export var FetchContext = React.createContext(fetch);
export var useFetch = function () {
    var fetchInContext = useContext(FetchContext);
    return fetchInContext;
};
export var FetchProvider = function (_a) {
    var value = _a.value, children = _a.children;
    var defaultFetch = useFetch();
    var fetch = value || defaultFetch;
    return React.createElement(FetchContext.Provider, { value: fetch }, children);
};
